// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TCreateProjectLabelRequestPayload,
  TCreateProjectLabelResponsePayload,
  TCreateSLAPolicyRequestPayload,
  TCreateSLAPolicyResponsePayload,
  TCreateTicketingMessageRequestPayload,
  TCreateTicketingMessageResponsePayload,
  TDeleteProjectLabelRequestPayload,
  TDeleteProjectLabelResponsePayload,
  TDeleteSLAPolicyRequestPayload,
  TDeleteSLAPolicyResponsePayload,
  TEscalateConversationRequestPayload,
  TEscalateConversationResponsePayload,
  TEscalateConversationV2Request,
  TGetAssigneeCandidatesRequestPayload,
  TGetAssigneeCandidatesResponsePayload,
  TGetTicketRequestPayload,
  TGetTicketResponsePayload,
  TGetTicketingConversationsRequestPayload,
  TGetTicketingConversationsResponsePayload,
  TGetTicketingMessagesRequestPayload,
  TGetTicketingMessagesResponsePayload,
  TListProjectLabelsRequestPayload,
  TListProjectLabelsResponsePayload,
  TListSLAPoliciesRequestPayload,
  TListSLAPoliciesResponsePayload,
  TListTicketsRequestPayload,
  TListTicketsResponsePayload,
  TSetTicketingMessagesToReadRequestPayload,
  TSetTicketingMessagesToReadResponsePayload,
  TUpdateProjectLabelRequestPayload,
  TUpdateProjectLabelResponsePayload,
  TUpdateSLAPolicyRequestPayload,
  TUpdateSLAPolicyResponsePayload,
  TUpdateTicketRequestPayload,
  TUpdateTicketResponsePayload,
  TUpdateTicketV2Request,
} from './ticketing.types.ts';

export const createTicketingApi = (transport: TApiTransport) => ({
  /** Creates a project label */
  createProjectLabel: (
    payload: TCreateProjectLabelRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TCreateProjectLabelRequestPayload,
      TCreateProjectLabelResponsePayload
    >('/create_project_label', payload, options),

  /** Creates an SLA policy */
  createSlaPolicy: (
    payload: TCreateSLAPolicyRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TCreateSLAPolicyRequestPayload,
      TCreateSLAPolicyResponsePayload
    >('/create_sla_policy', payload, options),

  /** Sends a message on a ticket conversation */
  createTicketingMessage: (
    payload: TCreateTicketingMessageRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TCreateTicketingMessageRequestPayload,
      TCreateTicketingMessageResponsePayload
    >('/create_ticketing_message', payload, options),

  /** Deletes a project label */
  deleteProjectLabel: (
    payload: TDeleteProjectLabelRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteProjectLabelRequestPayload,
      TDeleteProjectLabelResponsePayload
    >('/delete_project_label', payload, options),

  /** Deletes an SLA policy */
  deleteSlaPolicy: (
    payload: TDeleteSLAPolicyRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteSLAPolicyRequestPayload,
      TDeleteSLAPolicyResponsePayload
    >('/delete_sla_policy', payload, options),

  /** Escalates a conversation to a human */
  escalateConversation: (
    payload: TEscalateConversationRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TEscalateConversationRequestPayload,
      TEscalateConversationResponsePayload
    >('/escalate_conversation', payload, options),

  /** Escalates a conversation to a human with optional file attachments */
  escalateConversationV2: (
    payload: TEscalateConversationV2Request,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TEscalateConversationV2Request,
      TEscalateConversationResponsePayload
    >('/escalate_conversation_v2', payload, {
      ...options,
      contentType: 'multipart/form-data',
    }),

  /** Lists candidate ticket assignees */
  getAssigneeCandidates: (
    payload: TGetAssigneeCandidatesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetAssigneeCandidatesRequestPayload,
      TGetAssigneeCandidatesResponsePayload
    >('/get_assignee_candidates', payload, options),

  /** Returns a ticket */
  getTicket: (
    payload: TGetTicketRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetTicketRequestPayload, TGetTicketResponsePayload>(
      '/get_ticket',
      payload,
      options,
    ),

  /** Lists ticket conversations */
  getTicketingConversations: (
    payload: TGetTicketingConversationsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetTicketingConversationsRequestPayload,
      TGetTicketingConversationsResponsePayload
    >('/get_ticketing_conversations', payload, options),

  /** Lists a ticket conversation's messages */
  getTicketingMessages: (
    payload: TGetTicketingMessagesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetTicketingMessagesRequestPayload,
      TGetTicketingMessagesResponsePayload
    >('/get_ticketing_messages', payload, options),

  /** Lists project labels */
  listProjectLabels: (
    payload: TListProjectLabelsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TListProjectLabelsRequestPayload,
      TListProjectLabelsResponsePayload
    >('/list_project_labels', payload, options),

  /** Lists SLA policies */
  listSlaPolicies: (
    payload: TListSLAPoliciesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TListSLAPoliciesRequestPayload,
      TListSLAPoliciesResponsePayload
    >('/list_sla_policies', payload, options),

  /** Lists tickets */
  listTickets: (
    payload: TListTicketsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TListTicketsRequestPayload, TListTicketsResponsePayload>(
      '/list_tickets',
      payload,
      options,
    ),

  /** Marks ticket messages as read */
  setTicketingMessagesToRead: (
    payload: TSetTicketingMessagesToReadRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSetTicketingMessagesToReadRequestPayload,
      TSetTicketingMessagesToReadResponsePayload
    >('/set_ticketing_messages_to_read', payload, options),

  /** Updates a project label */
  updateProjectLabel: (
    payload: TUpdateProjectLabelRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateProjectLabelRequestPayload,
      TUpdateProjectLabelResponsePayload
    >('/update_project_label', payload, options),

  /** Updates an SLA policy */
  updateSlaPolicy: (
    payload: TUpdateSLAPolicyRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateSLAPolicyRequestPayload,
      TUpdateSLAPolicyResponsePayload
    >('/update_sla_policy', payload, options),

  /** Updates a ticket */
  updateTicket: (
    payload: TUpdateTicketRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TUpdateTicketRequestPayload, TUpdateTicketResponsePayload>(
      '/update_ticket',
      payload,
      options,
    ),

  /** Updates a ticket with optional file attachments */
  updateTicketV2: (
    payload: TUpdateTicketV2Request,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TUpdateTicketV2Request, TUpdateTicketResponsePayload>(
      '/update_ticket_v2',
      payload,
      { ...options, contentType: 'multipart/form-data' },
    ),
});
